<template>
	<section>
		<section class="c" :class="is_web_css">
			<!-- header 不可拖拽 -->
			<div class="view-content" :style="{ backgroundColor: info.backgroundColor, backgroundImage: 'url(' + info.backgroundImage + ')' }">
				<template v-for="(item, index) in view">
					<div v-if="index > 0" :data-index="index" :key="index" class="item">
						<!-- waiting -->
						<template v-if="item.status && item.status == 2">
							<div class="wait">{{ item.type }}</div>
						</template>
						<template v-else>
							<component
								:is="typeList[item.type]['com']"
								:ref="typeList[item.type]['ref']"
								:data="item"
								:className="className[item.tabType]"
								@on-butClick-submit="butClick(item)"
							></component>
						</template>
					</div>
				</template>
			</div>
		</section>
	</section>
</template>

<script>
import { Toast, Dialog } from 'vant';
import axios from 'axios';
// import Draggable from 'vuedraggable';
// import { imageUpload } from '@/api/commodity'
// import EditForm from '@/components/Edit/index';
import Product from '@/components/View/Product';
import Images from '@/components/View/Images';
import Banner from '@/components/View/Banner';
import imageAndText from '@/components/View/imageAndText';
import videoAndText from '@/components/View/videoAndText';
import fromInfo from '@/components/View/fromInfo';
import button_component from '@/components/View/button_component';
import text_component from '@/components/View/text_component';
import video_component from '@/components/View/video_component';
import bookShelf from '@/components/View/bookShelf';
import courseVideo from '@/components/View/courseVideo';
import courseCatalogue from '@/components/View/courseCatalogue';
import bookLink from '@/components/View/bookLink';
import CourseIntroduction from '@/components/View/CourseIntroduction';
import relatedReading from '@/components/View/relatedReading';
import doctorsSharing from '@/components/View/doctorsSharing';
import combinedMedica from '@/components/View/combinedMedica';
import productDisplay from '@/components/View/productDisplay';

export default {
	components: {
		// EditForm,
		// Draggable,
		Product,
		Images,
		Banner,
		imageAndText,
		videoAndText,
		fromInfo,
		button_component,
		text_component,
		video_component,
		bookShelf,
		courseVideo,
		courseCatalogue,
		bookLink,
		CourseIntroduction,
		relatedReading,
		doctorsSharing,
		combinedMedica,
		productDisplay,
	},
	data() {
		return {
			typeList: {
				banner: {
					name: '轮播图',
					icon: 'el-icon-picture',
					com: Banner,
				},
				product: {
					name: '商品',
					icon: 'el-icon-s-goods',
					com: Product,
				},
				images: {
					name: '图片',
					icon: 'el-icon-picture',
					com: Images,
				},
				imageAndText: {
					name: '图文组件',
					icon: 'el-icon-document',
					com: imageAndText,
				},
				videoAndText: {
					name: '视文组件',
					icon: 'el-icon-video-camera',
					com: videoAndText,
				},
				fromInfo: {
					name: '表单信息',
					icon: 'el-icon-edit-outline',
					com: fromInfo,
					ref: 'fromInfo',
				},
				button_component: {
					name: '按钮',
					icon: 'el-icon-thumb',
					com: button_component,
				},
				text_component: {
					name: '文字',
					icon: 'el-icon-postcard',
					com: text_component,
				},
				video_component: {
					name: '视频',
					icon: 'el-icon-video-play',
					com: video_component,
				},
				bookShelf: {
					name: '书架',
					icon: 'el-icon-notebook-2',
					com: bookShelf,
				},
				courseVideo: {
					name: '课程视频',
					icon: 'el-icon-video-camera',
					com: courseVideo,
				},
				courseCatalogue: {
					name: '课程目录',
					icon: 'el-icon-reading',
					com: courseCatalogue,
				},
				CourseIntroduction: {
					name: '课程简介',
					icon: 'el-icon-document',
					com: CourseIntroduction,
				},
				bookLink: {
					name: '电子书跳转',
					icon: 'el-icon-position',
					com: bookLink,
				},
				relatedReading: {
					name: '相关阅读',
					icon: 'el-icon-notebook-1',
					com: relatedReading,
				},
				doctorsSharing: {
					name: '名医分享',
					icon: 'el-icon-share',
					com: doctorsSharing,
				},
				combinedMedica: {
					name: '联合用药',
					icon: 'el-icon-first-aid-kit',
					com: combinedMedica,
				},
				productDisplay: {
					name: '产品展示',
					icon: 'el-icon-copy-document',
					com: productDisplay,
				},
			},
			view: [
				{
					type: 'info',
					title: '这个是标题!',
					backgroundImage: '',
				},
			],
			title: '页面标题',
			type: '',
			index: null, // 当前组件的索引
			className: {
				1: 'one',
				2: 'two',
				3: 'three',
			},
			is_web_css: '',
			activityId: this.$route.query.id, //活动详情ID
			token: '',
			aiId: '', //活动主键
		};
	},

	computed: {
		info() {
			return this.view[0];
		},
	},
	mounted() {
		if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
			this.getToken();
			let that = this;
			this.$bridge.registerhandler('refreshList', () => {
				that.getToken();
			});
			// this.token = this.$route.query.webToken;
			// this.getActivityId();
		} else {
			this.token = this.$route.query.webToken;
			if (this.$route.query.linkType == 'template') {
				this.is_template_view();
			} else {
				this.getActivityId();
			}
			this.is_web_css = 'is_web_css';
		}
	},
	methods: {
		// 获取token
		getToken() {
			let that = this;
			if (navigator.userAgent.indexOf('kcgy') == -1) {
				window.location.href = 'https://app.kcguoyi.com/download/#/';
				return false;
			}
			this.$bridge.callHandler('loadToken', null, (response) => {
				if (response == '' || response.length <= 0) {
					that.$bridge.callHandler('login', null, function (response) {});
					return false;
				}
				that.token = response;
				that.getActivityId();
			});
		},
		//获取模板详情
		is_template_view() {
			var url = process.env.VUE_APP_BASE_API + '/act/template/h5/' + this.$route.query.id;
			axios.get(url, { headers: { Authorization: 'Bearer ' + this.token, clientOs: 'h5' } }).then((res) => {
				if (res.data.code != 200) return false;
				if (res.data.data.atContent == null || res.data.data.atContent == 'null' || res.data.data.atContent == '') {
					this.$message.error('此活动未配置数据！');
					return false;
				} else {
					var newJson = JSON.parse(res.data.data.atContent);
					document.title = newJson[0].title;
					this.view = newJson;
				}
			});
		},

		//根据活动的详情页ID显示数据
		getActivityId() {
			var url = process.env.VUE_APP_BASE_API + '/act/page/h5/' + this.$route.query.id;
			axios.get(url, { headers: { Authorization: 'Bearer ' + this.token, clientOs: 'h5' } }).then((res) => {
				if (res.data.code != 200) return false;
				if (res.data.data.apContent == null || res.data.data.apContent == 'null' || res.data.data.apContent == '') {
					this.$message.error('此活动未配置数据！');
					return false;
				} else {
					//判断活动是否有效及时间范围内
					var actStartTime = new Date(res.data.data.actStartTime.replace(/-/g, '/')).getTime();
					var actEndTime = new Date(res.data.data.actEndTime.replace(/-/g, '/')).getTime();
					var myDate = new Date().getTime();
					var actStatusCode = res.data.data.actStatusCode; //0 活动正常 1活动不正常
					if (this.is_web_css == '') {
						if (myDate < actStartTime || myDate > actEndTime || actStatusCode == '1') {
							this.$router.replace('/defaultPage');
							return false;
						}
					}
					var newJson = JSON.parse(res.data.data.apContent);
					document.title = newJson[0].title;
					for (var i = 0; i < newJson.length; i++) {
						newJson[i]['token'] = this.token;
						newJson[i]['aiId'] = res.data.data.aiId;
						newJson[i]['abId'] = res.data.data.abId;
						this.aiId = res.data.data.aiId;
						if (newJson[i].type == 'button_component' && newJson[i].subType == 'AISZ') {
							axios
								.post(
									process.env.VUE_APP_BASE_API + '/act/questionnaire/h5/selectTongue',
									{ aiId: res.data.data.aiId },
									{ headers: { Authorization: 'Bearer ' + this.token, clientOs: 'h5' } }
								)
								.then((res) => {
									if (res.data.code == 200) {
										setTimeout(() => {
											window.location.href = res.data.msg;
										}, 1000);
									}
								});
						}
					}
					this.view = newJson;
				}
			});
		},

		//表单的提交
		butClick(e) {
			var formData = this.$refs.fromInfo[0].form;
			var lableData = this.$refs.fromInfo[0].lable;
			var subType = e.subType;
			var url = process.env.VUE_APP_BASE_API + (subType == 'AISZ' ? '/act/questionnaire/h5/submitTongue' : '/act/questionnaire/h5/submit');
			// return false;
			var newJson = {
				aiId: this.aiId,
				...formData,
				tableHead: lableData.toString(),
			};
			if (formData.redeemCode && formData.redeemCode.trim() == '') {
				Toast('兑换码不能为空！');
				return false;
			}
			if (lableData.length != Object.keys(formData).length - 1) {
				Toast('请填写完整信息后进行兑换！');
				return false;
			}
			for (var i = 1; i < lableData.length + 1; i++) {
				if (formData[Object.keys(formData)[i]].trim() == '') {
					Toast('请填写完整信息后进行兑换！');
					return false;
				}
			}
			axios.post(url, newJson, { headers: { Authorization: 'Bearer ' + this.token, clientOs: 'h5' } }).then((res) => {
				if (res.data.code == 200) {
					Dialog({ message: '兑换成功！' });
					if (subType == 'AISZ') {
						setTimeout(() => {
							window.location.href = res.data.msg;
						}, 1000);
					}
				} else {
					Dialog({ message: res.data.msg });
				}
			});
		},
	},
};
</script>
<style lang="scss" >
.view-content {
	background-repeat: no-repeat;
	background-size: 100% 100%;
}
section {
	overflow: hidden;
	.c {
		width: 100%;
	}
	.is_web_css {
		max-width: 375px;
		margin: 50px auto;
	}
}

.H5page_bookShelf .top {
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	margin: 0 auto;
	z-index: 99;
}
.H5page_bookShelf .bottom {
	width: 100%;
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	margin: 0 auto;
	z-index: 99;
}
.H5page_bookShelf .book-list {
	height: 100%;
	padding-top: 110px;
	padding-bottom: 120px;
}
.bookLink_fixed {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	margin: 0px auto 30px;
	z-index: 99;
}
.is_web_css_bookShelf .top {
	max-width: 375px;
}
.is_web_css_bookShelf .bottom {
	max-width: 375px;
}
.is_web_css_bookShelf .book-list {
	padding-top: 40px;
	padding-bottom: 50px;
}
</style>